<div mat-dialog-title style="position: relative">
  <p>
    {{ dialogTitle | translate }}
    @if (dialogTitleHelpLink) {
      <mat-icon class="help-icon" (click)="openHelpDoc()">
        help_outline
      </mat-icon>
    }
    <mat-icon class="setting-icon" (click)="toggleImportSettingPopup(true)">
      settings
    </mat-icon>
  </p>
  @if (showImportSettings) {
    <div class="import-settings-container boxShadow">
      <div class="import-settings">
        <shared-csv-import-settings
          (toggleImportSettingPopupEvent)="toggleImportSettingPopup($event)"
          (updateCSVSeparatorEvent)="updateCSVSeparator($event)"
          [initialSeparator]="csvSeparator"
        >
          <ng-content select="AdditionalimportSetting"></ng-content>
        </shared-csv-import-settings>
      </div>
      <span class="triangle-top"></span>
    </div>
  }
</div>

<div mat-dialog-content class="flex-layout-column dialog-container">
  <div class="select-container flex-20 flex flex-align--center">
    @if (selectedFile) {
      <p>
        <span class="fa fa-file-excel-o"></span>
        {{ selectedFile.name }}
      </p>
    }
    <label translate class="btn btn-default btn-file">
      <span class="fa fa-file-excel-o"></span>
      PROJECT_MANAGEMENT.JOBSITE_LAYOUT.SELECT_FILE
      <input
        type="file"
        accept=".csv"
        class="hidden"
        (change)="handleFileSelected($event)"
      />
    </label>
    <!--- slot for checkbox, and error message  -->
    <ng-content select="[top]"></ng-content>
  </div>

  <div class="import-preview flex-80">
    <div class="headlink">
      <form
        [formGroup]="headersForm"
        class="field-container flex-layout-column"
      >
        @for (headerKeyValue of headerFormKeys | keyvalue; track $index) {
          <div>
            <div class="flex">
              <mat-form-field class="flex-1">
                <mat-label>{{
                  headerTranslationPrefix + headerKeyValue.key | translate
                }}</mat-label>
                <mat-select formControlName="{{ headerKeyValue.key }}">
                  @if (!requiredHeaderFormKeys.includes(headerKeyValue.key)) {
                    <mat-option>None</mat-option>
                  }
                  @for (header of csvData.headers; track $index) {
                    <mat-option [value]="header">
                      {{ header }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              @if (getUnitValue(headerKeyValue.value)) {
                <mat-form-field class="flex-80px">
                  <mat-label style="font-weight: bold; color: red">{{
                    'CAGES.unit' | translate
                  }}</mat-label>
                  <mat-select
                    [value]="getUnitValue(headerKeyValue.value)"
                    (selectionChange)="
                      unitChanged(headerKeyValue.key, $event.value)
                    "
                  >
                    @for (unitOption of availableUnits; track $index) {
                      <mat-option [value]="unitOption">{{
                        unitOption
                      }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
            </div>
          </div>
        }
      </form>
    </div>
    <span class="divider"></span>
    <ng-content select="[importOption]"></ng-content>
    <div class="import-table">
      @if (getErrors.length > 0) {
        <div [class]="displayTable ? 'errors-wrapper' : 'full-errors-wrapper'">
          <ul class="csv-error">
            @for (error of getErrors; track $index) {
              <li>{{ error }}</li>
            }
          </ul>
        </div>
      }
      @if (displayTable) {
        <mat-paginator
          [pageSizeOptions]="[5, 10, 20]"
          showFirstLastButtons
        ></mat-paginator>
        <div class="table-container">
          <table mat-table [dataSource]="dataSource" matSort>
            @for (column of tableHeaders; track $index) {
              <ng-container matColumnDef="{{ column }}">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ translateWithUnit(column) }}
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element[column] }}
                </td>
              </ng-container>
            }
            <tr
              mat-header-row
              *matHeaderRowDef="tableHeaders; sticky: true"
            ></tr>
            <tr mat-row *matRowDef="let row; columns: tableHeaders"></tr>
          </table>
        </div>
      }
    </div>
  </div>
</div>
